<Label value={label}>
  <input
    class='input is-primary rounded'
    type="number"
    style="color: black"
    placeholder="เติมคำในช่องว่าง"
    bind:value={$value}
    required={false}
    list={label + '-datalist'}
  >
  <datalist id={label + '-datalist'}>
    {#each datalist as d}
      <option value={d}>
    {/each}
  </datalist>
</Label>

<script lang='ts'>
  import type { Writable } from "svelte/store";
  import { writable } from "svelte/store";
  import Label from "./Label.svelte";

  export let label: string | null = null;
  export let value: Writable<string> = writable('');
  export let datalist: string[] = []
</script>
